import queryString from 'qs';

export const getRequestApprovalTypeRequest = (id) => {
  const queries = { scheduleId: id };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getRequestApprovalTypeRequest;
